// export const CORE_API_ENDPOINT = 'https://tbqapi.rmbainisys.com/api'
// export const CORE_API_ENDPOINT = 'https://rmtb.bainisyspro.com/api'
// export const CORE_API_ENDPOINT = 'http://localhost:1993'
export const CORE_API_ENDPOINT = '/api'


// WEBPACK FOOTER //
// ./src/lib/api.js